import { useState } from 'react';
import { IDrawerConfig } from '../../components/customDrawer';

const useDrawerProvider = () => {
	const [drawerConfig, setDrawerConfig] = useState<IDrawerConfig>({ isOpen: false });

	return {
		drawerConfig,
		setDrawerConfig
	};
};

export default useDrawerProvider;
